import toastrPositions from '@gef-ui/components/organisms/Toastr/toastrPositions';
import { handleActions } from '@gef-ui/utils/fsaActions';
import { actionTypes } from '../../constants';
import addToast from '../addToast';
import removeToast from '../removeToast';
const toastrReducerMap = {
    [actionTypes.ADD_TOAST]: addToast,
    [actionTypes.REMOVE_TOAST]: removeToast
};
export default handleActions(toastrReducerMap, {
    toasts: [],
    config: {
        newestOnTop: true,
        position: toastrPositions.TOP_RIGHT,
        preventDuplicates: true
    }
});
